import React, { useState, useEffect } from "react";
import "../style/table.css";
import Pagination from "./Pagination";
import _ from "lodash";

function ProgramTable({ items, handleDeleteItem }) {
  const pageSize = 4;
  const [currentPage, setCurrentPage] = useState(1);
  const [programs, setPrograms] = useState([]);

  const handleDelete = (item) => {
    console.log("on " + item.name + " delete clicked");
    handleDeleteItem(item);
  };

  const handleOnPageClick = (number) => {
    setCurrentPage(number);
  };

  const paginate = () => {
    const start = (currentPage - 1) * pageSize;
    return _(items).slice(start).take(pageSize).value();
  };

  useEffect(() => {
    const paginatedProgramsArray = paginate(items);
    setPrograms(paginatedProgramsArray);
  }, [items, currentPage]);

  return (
    <div className="table_container">
      <table className="table farsi">
        <thead>
          <tr>
            <th className="farsi-header-for-program-table">عنوان</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {programs.map((p) => (
            <tr className="program-table-item" key={p._id}>
              <td className="col-11 row-title">{p.title}</td>
              <td className="col-1">
                <i
                  className="fa fa-trash delete-icon"
                  onClick={() => handleDelete(p)}
                  aria-hidden="true"
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        className="pagination-container"
        countOfItems={items.length}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageClicked={handleOnPageClick}
      ></Pagination>
    </div>
  );
}

export default ProgramTable;
